export default "__VITE_ASSET__BX6RK30o__"